import React, { Component } from "react";
import DOMPurify from "dompurify";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getBlogBySlug, getRecentBlogs } from "../../store/actions/blog";
import PageTitle from "../../components/shared/PageTitle";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import CartWidget from "../../components/shared/CartWidget";
import SEO from "../../components/shared/SEO";
import Loading from "../../components/shared/Loading";
import VibrantProductCard from "../../components/VibrantProductCard";
import styles from "../../thema/style";
import { PUBLIC_URL } from "../../config";

class BlogDetail extends Component {
  componentDidMount() {
    this.props.getBlogBySlug(this.props.match.params.slug);
    this.props.getRecentBlogs(5);
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.slug !== this.props.match.params.slug) {
      this.props.getBlogBySlug(this.props.match.params.slug);
      window.scrollTo(0, 0);
    }
  }

  formatDate(dateStr) {
    if (!dateStr) return "";
    var date = new Date(dateStr);
    var months = [
      "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
      "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
    ];
    return date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
  }

  render() {
    var blog = this.props.blog.currentBlog;
    var recentBlogs = this.props.blog.recentBlogs || [];
    var fetching = this.props.blog.fetching;
    var currentSlug = this.props.match.params.slug;

    var otherBlogs = recentBlogs.filter(function(b) {
      return b.slug !== currentSlug;
    });

    return (
      <React.Fragment>
        {blog && (
          <SEO
            title={(blog.meta_title || blog.title) + " - Botaniksan Blog"}
            description={blog.meta_description || blog.summary || ""}
            keywords={blog.meta_keywords || ""}
            url={"/blog/" + blog.slug}
            type="article"
          />
        )}
        <PageTitle title={blog ? blog.title : "Blog"} />
        <div className="row">
          <div className="container">
            <div className="row">
              <div className="col-md-9">
                <div style={{ marginTop: 20, marginBottom: 50 }}>
                  {fetching ? (
                    <div style={{ textAlign: "center", padding: "40px 0" }}>
                      <Loading />
                    </div>
                  ) : !blog ? (
                    <div style={{ textAlign: "center", padding: "40px 0" }}>
                      <h4>Blog yazısı bulunamadı.</h4>
                      <Link to="/blog" style={{ color: "#28a745" }}>Tüm Blog Yazılarına Dön</Link>
                    </div>
                  ) : (
                    <React.Fragment>
                      {blog.image && (
                        <img
                          src={PUBLIC_URL(blog.image)}
                          alt={blog.title}
                          style={{ width: "100%", maxHeight: 400, objectFit: "cover", borderRadius: 8, marginBottom: 20 }}
                        />
                      )}
                      <div style={{ marginBottom: 15 }}>
                        <small style={{ color: "#999" }}>
                          {this.formatDate(blog.created_at)}
                          {blog.viewCount > 0 && (
                            <span> &middot; {blog.viewCount} görüntülenme</span>
                          )}
                        </small>
                      </div>
                      <h2 style={{ marginBottom: 20, color: "#333" }}>{blog.title}</h2>
                      {blog.tags && blog.tags.length > 0 && (
                        <div style={{ marginBottom: 20 }}>
                          {blog.tags.map(function(tag, i) {
                            return (
                              <span key={i} style={{
                                display: "inline-block",
                                backgroundColor: "#e8f5e9",
                                color: "#2e7d32",
                                padding: "4px 12px",
                                borderRadius: 20,
                                fontSize: 12,
                                marginRight: 8,
                                marginBottom: 5,
                              }}>
                                {tag}
                              </span>
                            );
                          })}
                        </div>
                      )}
                      <div
                        className="blog-content"
                        style={{ lineHeight: 1.8, fontSize: 15, color: "#444" }}
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(blog.content)
                        }}
                      />
                    </React.Fragment>
                  )}
                </div>
              </div>
              <div className="col-md-3">
                {/* Son Blog Yazıları Widget */}
                <div style={{
                  backgroundColor: "#fff",
                  border: "1px solid #eee",
                  borderRadius: 8,
                  padding: 20,
                  marginBottom: 20,
                  marginTop: 20,
                }}>
                  <h6 style={{ fontWeight: 700, marginBottom: 15, paddingBottom: 10, borderBottom: "2px solid #28a745" }}>
                    Son Blog Yazıları
                  </h6>
                  {otherBlogs.length === 0 ? (
                    <p style={{ fontSize: 13, color: "#999" }}>Başka blog yazısı bulunmamaktadır.</p>
                  ) : (
                    otherBlogs.map(function(b) {
                      return (
                        <div key={b.id} style={{ marginBottom: 15, paddingBottom: 15, borderBottom: "1px solid #f0f0f0" }}>
                          <Link to={"/blog/" + b.slug} style={{ display: "flex", textDecoration: "none" }}>
                            {b.image ? (
                              <img
                                src={PUBLIC_URL(b.image)}
                                alt={b.title}
                                style={{ width: 60, height: 60, objectFit: "cover", borderRadius: 6, marginRight: 10, flexShrink: 0 }}
                              />
                            ) : (
                              <div style={{ width: 60, height: 60, backgroundColor: "#f5f5f5", borderRadius: 6, marginRight: 10, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <i className="fas fa-image" style={{ color: "#ccc" }}></i>
                              </div>
                            )}
                            <div>
                              <p style={{ fontSize: 13, fontWeight: 600, color: "#333", marginBottom: 4, lineHeight: 1.3 }}>
                                {b.title}
                              </p>
                              <small style={{ color: "#999", fontSize: 11 }}>{this.formatDate(b.created_at)}</small>
                            </div>
                          </Link>
                        </div>
                      );
                    }.bind(this))
                  )}
                  <Link to="/blog" style={{ color: "#28a745", fontSize: 13, fontWeight: 600, textDecoration: "none" }}>
                    Tüm Yazıları Gör &rarr;
                  </Link>
                </div>
                <CartWidget />
                <CategoriesWidget />
              </div>
            </div>
          </div>
        </div>

        {/* Tavsiye Edilen Ürünler - Tam genişlik */}
        {blog && blog.recommendedProducts && blog.recommendedProducts.length > 0 && (
          <div style={{ padding: "40px 0" }}>
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className={styles.headerSectionTitle}>
                    <h2 className={styles.featuredProductTitle}>
                      TAVSİYE EDİLEN ÜRÜNLER
                      <span>
                        <span className="bg-transparent">
                          <FontAwesomeIcon
                            icon={["fas", "leaf"]}
                            size="lg"
                            color={"#88c000"}
                          />
                        </span>
                      </span>
                    </h2>
                  </div>
                </div>
              </div>
              <div className="row">
                {blog.recommendedProducts.map(function(product, index) {
                  return (
                    <div
                      key={product.id}
                      className="col-xl-3 col-lg-4 col-md-6 col-sm-12"
                      style={{ marginBottom: 24 }}
                    >
                      <VibrantProductCard {...product} />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

var mapStateToProps = function(state) {
  return { blog: state.blog };
};
var mapDispatchToProps = {
  getBlogBySlug: getBlogBySlug,
  getRecentBlogs: getRecentBlogs,
};

export default connect(mapStateToProps, mapDispatchToProps)(BlogDetail);



// WEBPACK FOOTER //
// ./src/routers/BlogDetail/index.js